/* eslint-disable @typescript-eslint/ban-ts-comment */
import { SaveButton, useNotify, useRecordContext, useRedirect } from 'react-admin';
import { getToken } from '../authentication/authProvider';
import { useAppLocationState } from '@react-admin/ra-navigation';

export const FuneralSaveButton = () => {
  const redirect = useRedirect();
  const notify = useNotify();
  const [location ] = useAppLocationState();

  return (
    <>
    {!location.path.includes('funerals.create') ? 
    <>
    <SaveButton label="Save and Close" />
    <SaveButton 
        label="Save"
        sx={{marginLeft: '20px'}}
        mutationOptions={{
            onSuccess: () => {
                notify('Funeral saved');
            }}
        }
        type="button"
        variant="text"
    />
    </>
    : 
    <SaveButton label="Save and Create" />

    }
</>
  )
  
};
